import { type ReactNode } from 'react';

/** Layout das telas de autenticação (UX-PAINEL-INTERNO §1). Card centralizado. */
export function TelaAuth({ children }: { children: ReactNode }): ReactNode {
  return (
    <div className="flex min-h-screen items-center justify-center bg-fundo px-[var(--gutter)] py-10">
      <div className="w-full max-w-[380px]">
        <div className="mb-6 text-center font-display text-xl font-bold tracking-[0.02em] text-tinta-forte">
          Conexão Varga
        </div>
        <div className="rounded-2 border border-linha bg-superficie-alta p-6">{children}</div>
      </div>
    </div>
  );
}
